export default __webpack_public_path__ + "img/img_table_benefits-130aaca4cbfa933121bd6d11f2df3e03.png";